'use client';

import { FC, PropsWithChildren, useMemo, useEffect } from 'react';

import { NormalizedEntity } from '@ravago/shared/page-data/models/contentful-mapped';

import { PageRendererContext } from '../../../context/page-renderer-context';

interface Props extends PropsWithChildren {
   isConsumer: boolean;
   locale: string;
   contentEntity: NormalizedEntity | null;
   acceptWebp: boolean;
   assetBasePath: string;
}

const Providers: FC<Props> = ({ isConsumer, locale, contentEntity, acceptWebp, assetBasePath, children }) => {
   const value = useMemo(
      () => ({
         isConsumer,
         locale,
         contentEntity,
         acceptWebp,
         assetBasePath
      }),
      [isConsumer, locale, contentEntity, acceptWebp, assetBasePath]
   );

   useEffect(() => {
      if (isConsumer && typeof window !== 'undefined') {
         const scrollPosition = localStorage.getItem('navigationPendingScrollPosition');

         if (scrollPosition) {
            window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: 'smooth' });
            localStorage.removeItem('navigationPendingScrollPosition');
         }
      }
   }, []);

   return <PageRendererContext value={value}>{children}</PageRendererContext>;
};

export default Providers;
